import React from 'react';
import { Container, Typography, Paper, Box } from '@mui/material';

export default function About() {
    return (
        <Container maxWidth="md">
            <Paper elevation={3} sx={{ p: 4, mt: 4 }}>
                <Typography variant="h4" gutterBottom component="h1" color="primary">
                    About Black Cat Rare Coins
                </Typography>
                <Box sx={{ mt: 2 }}>
                    <Typography variant="body1" paragraph>
                        Welcome to Black Cat Rare Coins. We are dedicated to providing high-quality rare coins to collectors.
                        Our collection is carefully curated to ensure authenticity and value.
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Whether you are a seasoned numismatist or just starting your collection, we have something for you.
                        Explore our inventory and find your next treasure.
                    </Typography>
                </Box>
            </Paper>
        </Container>
    );
}
